import { EOIFinanceStatus, EOIPaymentMode } from "../../../../config/constant";

export const PaymentbuildPayload = (
  multiFormikValues,
  paymentFormikValues,
  totalAmountPayable,
  saveForLater,
  activeStep,
  originalTransactions,
) => {
  const { transactions } = multiFormikValues;

  const formattedTransactions = transactions
    .map((tx) => {
      if (tx.paymentMethod === EOIPaymentMode.OFFLINE) {

        const original = originalTransactions?.find(o => o.id === tx.id);
        const hasEdits = original
          ? (
              tx.offlineRadioOptions !== original.paymentMethod ||
              tx.bankName !== original.bankName ||
              String(tx.amount) !== original.amount ||
              tx.date !== original.date ||
              (tx.paymentProof?.[0] || null) !== original.paymentProof ||
              tx.transactionNo !== (original.chequeDDNumber || original.transactionNumber)
            )
          : true;

        let status = tx.status;
        if ((tx.status === EOIFinanceStatus.REJECTED && hasEdits) || !status) {
          status = EOIFinanceStatus.UNVERIFIED;
        }


        return {
          id: tx.id,
          paymentMode: EOIPaymentMode.OFFLINE,
          paidAmount: Number(tx.amount),
          status,
          date: tx.date,
          paymentDetails: {
            method: tx.offlineRadioOptions,
            chequeNumber:
              tx.offlineRadioOptions === "CHEQUE"
                ? tx.transactionNo
                : undefined,
            transactionNumber:
              tx.offlineRadioOptions !== "CHEQUE"
                ? tx.transactionNo
                : undefined,
            drawnOn: tx.bankName,
            // branchName: tx.branchName,
            // accountNumber: tx.accountNo,
            paymentProof: tx.paymentProof || [],
            isPhysicalPaymentProof: tx.isPhysicalPaymentProof || false,

          },
        };
      }
      // else if (tx.paymentMethod === EOIPaymentMode.GATEWAY) {
      //   // Gateway payment payload (always in this structure)
      //   return {
      //     paymentMode: EOIPaymentMode.GATEWAY,
      //     paidAmount: Number(tx.amount),
      //     paymentDetails: {
      //       bank: tx.bankName,
      //       email: tx.email,
      //       method: tx.onlineMethod,
      //       status: tx.status, // e.g. "success"
      //       contact: tx.contact,
      //       order_id: tx.orderId,
      //       paymentProof: tx.paymentProof || [],
      //       gatewayPaymentId: tx.gatewayPaymentId,
      //       paymentTransactionId: tx.paymentTransactionId,
      //       isPhysicalPaymentProof: false,
      //     },
      //   };
      // }
      return null;
    })
    .filter(Boolean);

  // Recovery Account details (from paymentOptionsFormik)
  const recoveryAccountDetails = {
    payeeName: paymentFormikValues.cancellationPayeename,
    bankName: paymentFormikValues.cancellationBankname,
    ifscCode: paymentFormikValues.cancellationIfscCode,
    swiftCode: paymentFormikValues.cancellationSwiftCode,
    accountNumber: paymentFormikValues.cancellationAccountNo,
    accountType: paymentFormikValues.cancellationAccountType,
    cancelledCheque: paymentFormikValues.cancelledCheque,
    isPhysicalCancelledCheque: paymentFormikValues.isPhysicalCancelledCheque,
  };

  // Final payload
  return {
    saveForLater,
    amountPayable: Number(totalAmountPayable),
    payments: formattedTransactions,
    recoveryAccountDetails,
    isAgreedOnTerms: paymentFormikValues?.termsAndConditions,
    lastStep:activeStep
  };
};

export const setFormValuesFromApplicantData = (
  applicantData,
  payments,
  multipaymentFormik,
  paymentFormik,
  termsValue
) => {
  if (!applicantData) return;

  const recoveryDetails = applicantData?.recoveryAccountDetails || applicantData?.paymentDetails?.recoveryAccountDetails;

  // ---- Map Transactions ----
  const mappedTransactions = (payments || []).map((tx) => {
    const method = tx?.paymentDetails?.method || "";

    return {
      id: tx?.id,
      paymentMethod: tx?.paymentMode === EOIPaymentMode.GATEWAY ? EOIPaymentMode.GATEWAY : EOIPaymentMode.OFFLINE,
      offlineRadioOptions: method,
      transactionNo:
        method === "CHEQUE"
          ? tx?.paymentDetails?.chequeNumber ||
            tx?.paymentDetails?.transactionNumber ||
            ""
          : tx?.paymentDetails?.transactionNumber || "",
      bankName: tx?.paymentDetails?.drawnOn || tx?.paymentDetails?.bank || "",
      // branchName: tx?.paymentDetails?.branchName || "",
      // accountNo: tx?.paymentDetails?.accountNumber || "",
      amount: tx?.paidAmount || "",
      paymentProof: tx?.paymentDetails?.paymentProof || [],
      status: tx?.status || EOIFinanceStatus.UNVERIFIED,
      date: tx?.date || "",
      type: "",
      isPaid:
        [EOIFinanceStatus.VERIFIED, EOIFinanceStatus.UNVERIFIED, EOIFinanceStatus.REVERSED]?.includes(
          tx?.status
        ) ||
        (tx?.paymentMode === EOIPaymentMode.GATEWAY &&
          tx?.status === EOIFinanceStatus.REJECTED),
      showUploadPopup: false,
      isPhysicalPaymentProof:
      tx?.paymentDetails?.isPhysicalPaymentProof || false,
      email: tx?.paymentDetails?.email || "",
      onlineMethod: tx?.paymentDetails?.method || "",
      contact: tx?.paymentDetails?.contact || "",
      orderId: tx?.paymentDetails?.order_id || "",
      gatewayPaymentId: tx?.paymentDetails?.gatewayPaymentId || "",
      paymentTransactionId: tx?.paymentDetails?.paymentTransactionId || "",
    };
  });

  multipaymentFormik.setValues({
    transactions:
      mappedTransactions.length > 0
        ? mappedTransactions
        : multipaymentFormik.initialValues.transactions,
  });

  // ---- Map Recovery Account ----
  paymentFormik.setValues({
    cancellationPayeename: recoveryDetails?.payeeName || "",
    cancellationBankname: recoveryDetails?.bankName || "",
    cancellationIfscCode: recoveryDetails?.ifscCode || "",
    residentStatus: applicantData?.applicant1?.personalDetails?.residentStatus || "",
    cancellationSwiftCode: recoveryDetails?.swiftCode || "",
    cancellationAccountNo: recoveryDetails?.accountNumber || "",
    cancellationAccountType: recoveryDetails?.accountType || "",
    cancelledCheque: recoveryDetails?.cancelledCheque || [],
    isPhysicalCancelledCheque: recoveryDetails?.isPhysicalCancelledCheque || false,
    termsAndConditions: Boolean(termsValue),
  });
};

export function formatDateIST(isoDate) {
  if (!isoDate) return "-";

  const date = new Date(isoDate);

  // Convert to IST (UTC + 5:30)
  const istOffset = 5 * 60 + 30; // minutes
  const istTime = new Date(date.getTime() + istOffset * 60 * 1000);

  const day = String(istTime.getUTCDate()).padStart(2, "0");
  const month = istTime.toLocaleString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = istTime.getUTCFullYear();

  // let hours = istTime.getUTCHours();
  // const ampm = hours >= 12 ? "pm" : "am";
  // hours = hours % 12 || 12;

  return `${day}-${month}-${year}`;
}

export function formatIndianNumber(num) {
  if (num === null || num === undefined || isNaN(num)) {
    return "0";
  }
  return Number(num).toLocaleString("en-IN");
}
